import { inject } from '@angular/core';
import { CanActivateFn, RedirectCommand, Router } from '@angular/router';
import {
  BASE_LAYER_LIST,
  BASE_LAYER_QUERY_PARAM_KEY,
  DEFAULT_BASE_LAYER,
} from './map';

export const baseLayerGuard: CanActivateFn = (route, state) => {
  const baseLayers = inject(BASE_LAYER_LIST);

  const urlBaseLayer = route.queryParams[BASE_LAYER_QUERY_PARAM_KEY];

  const baseLayer = baseLayers.find((layer) => layer === urlBaseLayer);

  if (!baseLayer) {
    const router = inject(Router);

    const url = new URL(state.url, window.location.origin);
    url.searchParams.set(BASE_LAYER_QUERY_PARAM_KEY, DEFAULT_BASE_LAYER);

    const urlTree = router.parseUrl(url.pathname + url.search);

    return new RedirectCommand(urlTree, {
      replaceUrl: true,
    });
  }

  return true;
};
